export const SET_FILTER_DATA = 'SET_DEPOSIT_FILTER_DATA';
export const CLEAR_FILTER_DATA = 'CLEAR_DEPOSIT_FILTER_DATA';

export const setFilterData = (data, page, size) => dispatch => {
  return dispatch({
      type: SET_FILTER_DATA,
      payload: {data, page, size}
    }
  )
};

export const clearFilterData = () => dispatch => {
  return dispatch({
      type: CLEAR_FILTER_DATA,
    }
  )
};







